import "./App.css";
import "./containers/global.css";
import LoginPage from "./containers/LoginPage/LoginPage";
import Layout from "./hocs/Layout";
import { Toaster } from "react-hot-toast";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import LogsListing from "./containers/LogsListing/LogsListing";
import ErrorPage from "./components/Error-Page/ErrorPage";
import SystemLogs from "./containers/SystemLogs/SystemLogs";
import StoreQC from "./containers/QC/StoreQC";
import BuyerQC from "./containers/QC/BuyerQC";

function ProtectedRoute({ children }) {
  const { authData } = useSelector((state) => state.loginSlice);
  return authData ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            duration: 1500,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />

      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <LogsListing />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction-logs"
          element={
            <ProtectedRoute>
              <Layout>
                <LogsListing />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/storeqc"
          element={
            <ProtectedRoute>
              <Layout>
                <StoreQC />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/buyerappqc"
          element={
            <ProtectedRoute>
              <Layout>
                <BuyerQC />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
